module.exports = __webpack_public_path__ + "img/interaction-sync.60d28591.webp";